/**
 * De onde saiu Passeio ou Comercial (cronograma, tarefa 3). "Voto de 3 vistas" não dizia
 * quem votou em quê, e a Sprinter que a frente chama de carro parecia um erro da IA inteira
 * quando era uma vista contra duas.
 *
 * Só **mostra** o voto: quem decide o grupo é `votar_grupo`, no domínio, e o grupo chega
 * pronto em `grupo`. Esta função não vota de novo.
 */
import { rotuloDaVista } from "../api/tipos";
import { grupoDaClasse } from "../leituras";

type Vista = {
  vista: string;
  classe: string | null;
  classe_confianca: number | null;
};

function emPct(v: number | null): string {
  if (v == null) return "";
  return ` ${Math.round(v <= 1 ? v * 100 : v)}%`;
}

export function votoDaClasse(vistas: Vista[], grupo: string | null): string {
  const comClasse = vistas
    .filter((v) => grupoDaClasse(v.classe))
    .sort((a, b) => (b.classe_confianca ?? 0) - (a.classe_confianca ?? 0));
  if (comClasse.length === 0) return "nenhuma vista viu veículo";
  const vencedor = grupoDaClasse(grupo) ?? grupoDaClasse(comClasse[0]?.classe);
  const a_favor = comClasse.filter((v) => grupoDaClasse(v.classe) === vencedor);
  const contra = comClasse.filter((v) => grupoDaClasse(v.classe) !== vencedor);
  const lista = (vs: Vista[]) =>
    vs
      .map((v) => `${rotuloDaVista(v.vista)}${emPct(v.classe_confianca)}`)
      .join(", ");
  const n = comClasse.length;
  const cabeca =
    n === 1
      ? ""
      : contra.length === 0
        ? `${n} vistas: `
        : `${a_favor.length} de ${n} vistas: `;
  const partes = [`${cabeca}${lista(a_favor)}`];
  for (const v of contra) {
    partes.push(
      `${rotuloDaVista(v.vista)} disse ${grupoDaClasse(v.classe)?.toLowerCase()}${emPct(v.classe_confianca)}`,
    );
  }
  return partes.join(" · ");
}
